<p-checkbox
  [formControl]="control()"
  [binary]="binary"
  [label]="$isRequired() ? label + ' *' : label"
  [name]="name"
  [tabindex]="tabindex"
  [inputId]="inputId"
  [styleClass]="styleClass"
  [labelStyleClass]="labelStyleClass"
  [ariaLabel]="ariaLabel"
  [ariaLabelledBy]="ariaLabelledBy"
  [readonly]="readonly"
  (onChange)="$onChange.emit($event)"
></p-checkbox>
